import { Component } from '@angular/core';
import { TranslateModule } from '@client/app/modules/translate.module';

@Component({
    selector: 'seo-missing-title',
    templateUrl: './missing-title.component.html',
    standalone: true,
    imports: [TranslateModule],
})
export class SeoMissingTitleComponent {
}
